export { default } from './NationalIdentityNumber'
export * from './NationalIdentityNumber'
